// accordion, dashboard table component render (2698948956)

/*

usha   09/29/2022  2698947782 Customization in custom window
ashraf 10/06/2022  2698947782 added comments to code, removed unusual code
ashraf 10/07/2022  2698947782 removed commented code
ashraf 10/15/2022  2698947782 Added custom windows code comments
suresh peddavoora 10/27/2022 2698947782  Removed class for Accordion Details
suresh peddavoora 10/28/2022 2698947782 Modified styles for accordion root
Ashraf 10/28/2022 2698947782 Added search form
*/

import React from 'react';
import SearchCustomWindow from './UDWSearchForm';


export default function UDWAccordion({
  title,
  children,
  UDWData,
  setWindowNumber,
  setIsCopyRowData,
  setEditExisting,
  setInitialValues,
  setFormData,
  changedWindowNumber,
  setChangedWindowNumber,
  setValue,
}) {
  return (
    <div>
      {/* <div className={classes.root}>
        <Accordion
          className="accordion-styling"
          elevation={0}
          expanded={expanded}
          onChange={handleChange("panel2")}
        >
          <AccordionDetails>
            <SearchCustomWindow
              UDWData={UDWData}
              setValue={setValue}
              changedWindowNumber={changedWindowNumber}
              setChangedWindowNumber={setChangedWindowNumber}
              setFormData={setFormData}
              setInitialValues={setInitialValues}
              setEditExisting={setEditExisting}
              setWindowNumber={setWindowNumber}
              setIsCopyRowData={setIsCopyRowData}
            />
          </AccordionDetails>
        </Accordion>
      </div> */}
      <SearchCustomWindow
        UDWData={UDWData}
        setValue={setValue}
        changedWindowNumber={changedWindowNumber}
        setChangedWindowNumber={setChangedWindowNumber}
        setFormData={setFormData}
        setInitialValues={setInitialValues}
        setEditExisting={setEditExisting}
        setWindowNumber={setWindowNumber}
        setIsCopyRowData={setIsCopyRowData}
      />
    </div>
  );
}
